import { IThemeInterface as IDatashopTheme } from '@datashop/theme';
import { injectGlobal } from 'styled-components';

const theme = {
  colors: {
    primary: '#dd4c4c',
    grey: '#ededed',
    darkGrey: '#d4d4d4',
    inactiveGrey: '#76797C',
    activeRed: '#D93737',
    lightGrey: '#fafafa',
    white: '#ffffff',
    stoneLight: '#e7e4e4',
  },
  weights: [400, 500, 700],
  _htmlFontSize: 10,
  baseFontSize: 1.4, // in rem
};

export type IThemeInterface = typeof theme & IDatashopTheme;

export default theme;

export const globalCss = () => injectGlobal`
  @import url('https://fonts.googleapis.com/icon?family=Material+Icons');
  @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700');

  html {
    font-size: 14px;
  }

  body {
    padding: 0;
    margin: 0;
    font-family: "Roboto", "Source Sans Pro", "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #2d2d2d;
    -webkit-font-smoothing: antialiased;
  }

  * {
    box-sizing: border-box;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8;
    background: rgba(0, 0, 0, 0.18);
    cursor: move;
    border: none;
  }

  ::-webkit-scrollbar-track {
    border-top: 0;
    border-bottom: 0;
    border: 0;
    border-radius: 0;
  }
`;
